import 'styles/react-data-grid/react-data-grid-drop-target.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { DropTarget } from 'react-dnd';

const rowComparer = (nextProps, currentProps) => {
  return (
    currentProps.columns !== nextProps.columns ||
    nextProps.row !== currentProps.row ||
    currentProps.colOverscanStartIdx !== nextProps.colOverscanStartIdx ||
    currentProps.colOverscanEndIdx !== nextProps.colOverscanEndIdx ||
    currentProps.colVisibleStartIdx !== nextProps.colVisibleStartIdx ||
    currentProps.colVisibleEndIdx !== nextProps.colVisibleEndIdx ||
    currentProps.isSelected !== nextProps.isSelected ||
    currentProps.isScrolling !== nextProps.isScrolling ||
    nextProps.height !== currentProps.height ||
    currentProps.isOver !== nextProps.isOver ||
    currentProps.expandedRows !== nextProps.expandedRows ||
    currentProps.canDrop !== nextProps.canDrop ||
    currentProps.forceUpdate === true ||
    currentProps.extraClasses !== nextProps.extraClasses
  );
};

let rowDropTarget = (Row) =>
  class extends React.Component {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
      return rowComparer(nextProps, this.props);
    }

    moveRow() {
      ReactDOM.findDOMNode(this).classList.add('slideUp');
    }

    render() {
      const { connectDropTarget, isOver, canDrop } = this.props;

      return connectDropTarget(
        <div>
          {isOver && canDrop && (
            <div
              style={{
                left: 0,
                height: 0,
                width: '100%',
                zIndex: 1,
                borderBottom: '1px solid black',
              }}
            />
          )}
          <Row {...this.props} />
        </div>
      );
    }
  };

const target = {
  drop(props, monitor, component) {
    // Obtain the dragged item
    component.moveRow();
    let rowSource = monitor.getItem();
    let rowTarget = { idx: props.idx, data: props.row };
    props.onRowDrop({ rowSource, rowTarget });
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    draggedRow: monitor.getItem(),
  };
}

export default (Row) =>
  DropTarget('Row', target, collect, {
    arePropsEqual: (nextProps, currentProps) => !rowComparer(nextProps, currentProps),
  })(rowDropTarget(Row));
